import React, { useCallback } from 'react';
import { Linking, Alert } from 'react-native';
import { TextLink } from '../TextLink';
import type { PhoneLinkProps } from './types';

export const PhoneLink = ({
  phoneNumber,
  protocol,
  alertLabel = 'Something went wrong, try again later.',
  ...rest
}: PhoneLinkProps) => {
  const handlePress = useCallback(async () => {
    const url = `${protocol}:${phoneNumber}`;
    const isSupported = await Linking.canOpenURL(url);

    if (!isSupported) {
      Alert.alert(alertLabel);

      return;
    }

    await Linking.openURL(url);
  }, [phoneNumber, protocol, alertLabel]);

  return <TextLink onPress={handlePress} {...rest} />;
};
